<template>
  <div v-if="is_install === false" id="optimize99-ab-test-header" class="optimize99-ab-test-header-container">
    <div class="optimize99-ab-test-header">
      <!-- LOGO -->
      <div class="title">
        <div class="back mr-3" @click="goExperience">
          <span class="opt-icon-container">
            <v-icon color="#FFF">mdi-chevron-left</v-icon>
          </span>
        </div>
        <div class="logo">
          <img
            src="https://shoplineimg.com/61c975947448c5006965ee7c/6461c3ac8212c3000edbd5af/200x.webp?source_format=png"
          />
        </div>
        <div class="experience">
          <!-- <div class="opt-experience-name">{{data.urlView.name}}</div> -->
          <p class="opt-version-name">{{ data.urlView.name }}</p>
        </div>
      </div>

      <!-- 選擇器 -->
      <div class="content">
        <v-icon color="#FFFFFF" class="mr-3">
          {{ selected_device_type.icon }}
        </v-icon>
        <v-select
          v-model="selected_device_type"
          class="device_selector"
          :width="260"
          height
          :items="device_types"
          item-text="name"
          item-value="id"
          dense
          outlined
          hide-details
          return-object
          background-color="#FFF"
          @change="selectType"
        >
        </v-select>
      </div>

      <!-- 保存 -->
      <div class="action ml-15" @click="saveConfig">
        <div class="btn_action btn_action_bg_linear opt-save-btn">
          <span>存檔</span>
          <v-icon color="#FFF">mdi-chevron-right</v-icon>
        </div>
      </div>
    </div>

    <div class="optimize99-ab-test-subheader d-flex justify-end align-center pr-10">
      <v-tooltip v-if="!is_open_editor" bottom class="pa-0" attach="#optimize99-ab-test-header">
        <template #activator="{ on, attrs }">
          <v-btn
            v-if="!is_open_editor"
            icon
            v-bind="attrs"
            class="optimize99-ab-test-subheader-btn"
            v-on="on"
            @click="openEditor"
          >
            <i class="material-icons"> tune </i>
          </v-btn>
        </template>
        <span>編輯器</span>
      </v-tooltip>
    </div>
  </div>
</template>

<script>
import { eventBus } from '@/event_bus.js'
import { mapGetters } from 'vuex'
import // apiPatchView,
// apiGetViewWithData
'@/api/optimize.js'
import {
  apiUpdateSetting,
  apiGetOneSetting,
  apiUpdateOnlineUserPlugin,
  apiDeleteOnlineUserPlugin,
  apiUpdateCounterPlugin,
  apiDeleteCounterPlugin,
} from '@/api/urlview.js'

export default {
  name: 'Header',
  props: {
    data: Object,
    experience: Object,
    view: Object,
    view_data: Object,
    is_install: Boolean,
    init_step_historys: Array,
    init_step_history_index: Number,
    default_device_type: Object,
  },
  data() {
    return {
      experience_name: '',
      view_name: '',
      device_types: [
        {
          id: 'desktop',
          icon: 'mdi-monitor',
          name: '桌機',
        },
        {
          id: 'tablet',
          icon: 'mdi-tablet',
          name: '平板',
        },
        {
          id: 'mobile',
          icon: 'mdi-cellphone',
          name: '手機',
        },
      ],
      selected_device_type: this.default_device_type,
      step_historys: [],
      step_history_index: -1,
      device_history: {},
      is_changed: false,
      plugins: {},
      original_plugins: {},
      create_plugins: {},
      update_plugins: {},
      delete_plugins: {},
      plugin_type: {
        online_user: '在線人數',
        sales_counter: '銷售計數器',
      },
    }
  },
  computed: {
    ...mapGetters('optimize', ['is_open_editor']),
  },
  created: async function () {
    eventBus.$on('update-header-history', this.updateHistory)
    eventBus.$on('update-header-plugin-history', this.updatePluginHistory)
    this.step_historys = this.init_step_historys
    this.step_history_index = this.init_step_history_index
    this.initPlugin(this.data)
  },
  destroyed: function () {
    eventBus.$off('update-header-history', this.updateHistory)
    eventBus.$off('update-header-plugin-history', this.updatePluginHistory)
  },
  mounted: function () {},
  methods: {
    showPluginName(type) {
      let name = this.plugin_type[type]
      if (!name) {
        name = ''
      }
      return name
    },
    selectType: async function () {
      console.log('selected_device_type', this.selected_device_type)
      this.$store.commit('setDeviceType', this.selected_device_type.id)
      let currentQuery = { ...this.$route.query }
      currentQuery.device_type = this.selected_device_type.id
      await this.saveConfig(true)
      await this.$router.replace({ query: currentQuery })
      this.$router.go()
    },
    openEditor: function () {
      this.$store.commit('optimize/SET_IS_OPEN_EDITOR', true)
    },
    saveConfig: async function (is_silence) {
      // 存檔的話 只存到當前這步的歷史紀錄，
      let step_historys = this.step_historys
      let idx = this.step_history_index
      step_historys.splice(idx + 1, step_historys.length - idx - 1)
      idx = step_historys.length - 1
      this.step_historys = step_historys
      this.step_history_index = idx
      eventBus.$emit('update-editor-history', this.step_historys, this.step_history_index)
      // this.$store.commit('setHistoryIndex', idx)
      // this.$store.commit('setStepHistorys', step_historys)
      console.log('historys', this.step_historys)
      let new_step_historys = JSON.parse(JSON.stringify(this.step_historys))
      // 把original_info濾掉
      let clear_historys = []
      clear_historys = new_step_historys.map(function (step_history) {
        let tmp_history = {}
        let expected_fields = [
          'nodeName',
          'attribute',
          'selector',
          'type',
          'new_value',
          'method',
          'method',
          'css',
          'plugin_data',
          'target_selector',
          'param_name',
          'param_type',
        ]
        expected_fields.forEach(function (expected_field) {
          if (expected_field === 'plugin_data' && step_history.plugin_data) {
            let save_fields = ['type', 'id']
            console.log('filter_fields', step_history.plugin_data['type'])
            Object.keys(step_history.plugin_data).forEach(function (field_key) {
              if (save_fields.includes(field_key) === false) {
                delete step_history.plugin_data[field_key]
              }
            })
          }

          if (step_history[expected_field]) {
            tmp_history[expected_field] = step_history[expected_field]
          } else {
            tmp_history[expected_field] = ''
          }
        })
        return tmp_history
      })

      console.log('clear_historys1:', clear_historys)
      clear_historys = clear_historys.filter(function (clear_history) {
        return clear_history
        // if (clear_history.type !== 'plugin') {
        //     return clear_history
        // }
        // else if (clear_history.type === 'plugin' && clear_history.param_type !== 'attribute') {
        //     return clear_history
        // }
      })
      console.log('clear_historys2:', clear_historys)

      // 準備送API的格式
      console.log('data_addcolumn', this.data)
      let add_column = {}
      if (this.data.urlView.add_column) {
        add_column = JSON.parse(this.data.urlView.add_column)
      }
      console.log('data_addcolumn', add_column)
      add_column[this.$route.query.device_type] = step_historys
      console.log('header_save_addcolumn:', add_column)

      let param = {
        setting: {
          add_column: JSON.stringify(add_column),
        },
      }

      let that = this
      // 每個plugin種類檢查一次這次有變更的
      Object.keys(this.plugins).forEach(function (plugin_name) {
        param[plugin_name] = []
        that.create_plugins[plugin_name] = []
        that.update_plugins[plugin_name] = []
        that.delete_plugins[plugin_name] = []

        // 沒有view_key的通通刪掉
        let empty_id_settings = that.original_plugins[plugin_name].filter(function (p) {
          return p.view_key === ''
        })
        console.log('empty_id_settings:', empty_id_settings)
        that.delete_plugins[plugin_name] = that.delete_plugins[plugin_name].concat(empty_id_settings)

        let exist_id_settings = that.original_plugins[plugin_name].filter(function (p) {
          return p.view_key !== ''
        })

        // 頁面的plugins
        console.log('plugin_name:', plugin_name)
        console.log('that.plugins:', that.plugins)
        let plugins = that.plugins[plugin_name]
        plugins.forEach(function (plugin) {
          console.log('plugin.setting', plugin.setting)
          plugin.setting.status = plugin.status
          plugin.setting.id = plugin.id

          let target_idx = exist_id_settings.findIndex((obj) => obj.view_key === plugin.id)
          console.log('target_idx', target_idx)
          if (target_idx !== -1) {
            plugin.setting.id = exist_id_settings[target_idx].id
            if (plugin.setting.status === 'delete') {
              that.delete_plugins[plugin_name].push(plugin.setting)
            } else if (plugin.setting.status === 'update') {
              that.update_plugins[plugin_name].push(plugin.setting)
            }
          } else {
            if (plugin.status !== 'delete') {
              plugin.setting.add_column = JSON.stringify({
                view_key: plugin.setting.id,
                device_type: that.$route.query.device_type,
                // "selector": plugin.selector
              })
              delete plugin.setting.id
              that.create_plugins[plugin_name].push(plugin.setting)
            }
          }

          if (that.create_plugins[plugin_name].length > 0) {
            param[plugin_name] = that.handleRequestData(plugin_name, that.create_plugins[plugin_name])
          }
        })
      })
      console.log('original_plugins:', this.original_plugins)
      console.log('delete_plugins:', that.delete_plugins)
      console.log('update_plugins:', that.update_plugins)
      console.log('create_plugins:', that.create_plugins)
      console.log('save_param:', param)
      // let is_debug = false
      // if (!is_debug) {
      //     return
      // }
      let dialog_setting = {
        alert_type: {
          is_show: true,
          type: 'info',
          color: 'info',
          icon: 'mdi-information-variant-circle-outline',
        },
        is_show: true,
        title: '系統訊息',
        text: '儲存修改記錄中...',
        btns: [
          {
            text: '關閉',
            callback: this.closeBtn,
            color: 'grey',
          },
          {
            text: '返回設定',
            callback: this.goExperience,
            color: 'primary',
          },
        ],
        time: 0,
      }

      if (is_silence !== true) {
        eventBus.$emit('open-dialog', dialog_setting)
      }
      let resp = null
      try {
        resp = await apiUpdateSetting(this.$route.params.org_id, this.$route.params.id, param)
        resp = {
          result: 'success',
          data: resp.data,
        }
        await this.deletePlugin(this.delete_plugins)
        await this.updatePlugin(this.update_plugins)
      } catch (error) {
        console.log('update_error', error)
        let data = ''
        let reason = ''
        let result = 'fail'
        try {
          let error_msg = JSON.parse(error)
          let duplicates = JSON.parse(error_msg.msg)
          result = 'duplicate_fail'
          reason = '同一個網址有重疊的設定檔'
          data = duplicates
        } catch (error_2) {
          reason = error_2
        }

        resp = {
          result: result,
          data: data,
          error: reason,
        }
      }

      // let resp = await apiUpdateSetting(
      //     this.$route.params.org_id,
      //     this.$route.params.id,
      //  param)
      // .then(function(resp){
      //     if (resp.data.ok !== 1) {
      //         return {
      //             "result": "fail",
      //             "error": resp.data.msg
      //         }
      //     }
      //     else {
      //         return {
      //             "result": "success",
      //             "data": resp.data.data
      //         }
      //     }

      //     await this.deletePlugin(this.delete_plugins)
      //     await this.updatePlugin(this.update_plugins)

      // }).catch(function(error){
      //     return {
      //         "result": "fail",
      //         "error": error.response ?  error.response.data : error
      //     }
      // })

      // await this.deletePlugin(this.delete_plugins)
      // await this.updatePlugin(this.update_plugins)

      if (is_silence !== true) {
        if (resp.result === 'success') {
          dialog_setting.alert_type.type = 'success'
          dialog_setting.alert_type.color = 'success'
          dialog_setting.alert_type.icon = 'mdi-check-circle-outline'
          dialog_setting.text = '儲存成功'
          console.log(resp)
        } else {
          dialog_setting.alert_type.icon = 'mdi-alert-circle-outline'
          dialog_setting.alert_type.type = 'error'
          dialog_setting.alert_type.color = 'error'
          dialog_setting.text = resp.error
          dialog_setting.fail_type = resp.result
        }
        eventBus.$emit('open-dialog', dialog_setting)
      }

      // 重新取得一次view的plugin，並且初始化original_plugins
      // 視為和重新進入一樣
      try {
        let result = await apiGetOneSetting(this.$route.params.org_id, this.$route.params.id)
        console.log('reget_plugin: ', result)
        let data = result.data
        console.log('data', data)
        this.initPlugin(data)
        this.create_plugins = {}
        this.update_plugins = {}
        this.delete_plugins = {}
      } catch (error) {
        let message = '取得衝動外掛設定檔失敗，原因: '
        if (error.response) {
          message += error.response.data.msg
        } else {
          message += error
        }
        this.$root.vtoast.show({
          message: message,
        })
      }
    },
    closeBtn: function () {
      eventBus.$emit('open-dialog', {
        is_show: false,
      })
    },
    goExperience: function () {
      this.$router.go(-1)
    },
    updateHistory: function (historys, history_idx) {
      console.log('header更新歷史', historys)
      console.log('header更新歷史', history_idx)
      console.log('header更新歷史', this.selected_device_type)

      if (!this.device_history[this.selected_device_type.id]) {
        this.device_history[this.selected_device_type.id] = {
          step_historys: [],
          step_history_index: -1,
          unique_history: {},
        }
      }
      this.device_history[this.selected_device_type.id]['step_historys'] = historys
      this.device_history[this.selected_device_type.id]['step_history_index'] = history_idx
      this.step_historys = historys
      this.step_history_index = history_idx
      this.is_changed = true
      console.log('this.device_history', this.device_history)
    },
    updatePluginHistory: function (plugin_data, step) {
      console.log('header-plugin-history', plugin_data)
      console.log('methoddddd:', plugin_data.method)
      let plugin_type = plugin_data.type
      let target = plugin_data
      let target_idx = 0
      if (!this.plugins[plugin_type]) {
        this.plugins[plugin_type] = []
      }

      target_idx = this.plugins[plugin_type].findIndex((obj) => obj.id === target.id)

      switch (plugin_data.method) {
        case 'create':
          if (step === 'next') {
            if (target_idx !== -1) {
              this.plugins[plugin_type][target_idx]['status'] = 'create'
            } else {
              plugin_data.status = 'create'
              this.plugins[plugin_type].push(plugin_data)
            }
          } else {
            if (target_idx !== -1) {
              this.plugins[plugin_type][target_idx]['status'] = 'delete'
            } else {
              plugin_data['status'] = 'delete'
              plugin_data['created_by'] = 'auto'
              this.plugins[plugin_type].push(plugin_data)
            }
          }

          break
        case 'update':
          plugin_data.status = 'update'
          if (target_idx !== -1) {
            this.plugins[plugin_type][target_idx].status = 'update'
            if (step === 'next') {
              this.plugins[plugin_type][target_idx].setting = plugin_data.setting
            } else {
              this.plugins[plugin_type][target_idx].setting = plugin_data.old_setting
            }
          }
          // 找不到的狀況是，一進來讀完舊檔直接改，原本的plugin會是空的
          else {
            plugin_data['created_by'] = 'auto'
            this.plugins[plugin_type].push(plugin_data)
            console.log(`${plugin_type}_${plugin_data.method}_找不到`)
          }
          break
        case 'delete':
          if (target_idx !== -1) {
            if (step === 'next') {
              this.plugins[plugin_type][target_idx]['status'] = 'delete'
              // this.plugins[plugin_type].splice(target_idx, 1)
            } else {
              this.plugins[plugin_type][target_idx]['status'] = 'update'
              // this.plugins[plugin_type].push(plugin_data)
            }
          } else {
            plugin_data['status'] = 'delete'
            plugin_data['created_by'] = 'auto'
            this.plugins[plugin_type].push(plugin_data)
            console.log(`${plugin_type}_${plugin_data.method}_找不到`)
          }
          break
        default:
          console.log('unknown_plugin_update_method')
      }

      console.log('after_update_plugins:', this.plugins)
    },
    initPlugin(view_data) {
      let that = this
      // 把每個plugin的設定檔讀進來
      Object.keys(view_data).forEach(function (view_feature) {
        if (!view_feature.includes('View') && !view_feature.includes('status')) {
          that.original_plugins[view_feature] = JSON.parse(JSON.stringify(view_data[view_feature]))
        }
      })

      // 把前端的key讀出來
      Object.keys(this.original_plugins).forEach(function (plugin_name) {
        console.log('plugin_name', plugin_name)
        console.log('that.original_plugins', that.original_plugins)
        that.original_plugins[plugin_name].forEach(function (plugin) {
          plugin['view_key'] = ''
          try {
            let add_column = JSON.parse(plugin.add_column)
            plugin['view_key'] = add_column['view_key']
          } catch (error) {
            console.log('parse_add_column_error', error)
          }
        })
      })
      this.plugins = []
      console.log('init_original_plugin', this.original_plugins)
      console.log('init_plugins', this.plugins)
    },
    async deletePlugin(delete_plugins) {
      let plugin_types = Object.keys(delete_plugins)

      for (let idx = 0; idx < plugin_types.length; idx++) {
        let plugin_type = plugin_types[idx]

        if (!delete_plugins[plugin_type]) {
          continue
        }

        for (let idx2 = 0; idx2 < delete_plugins[plugin_type].length; idx2++) {
          let target_plugin = delete_plugins[plugin_type][idx2]
          let result = ''
          switch (plugin_type) {
            case 'online_user':
              result = await apiDeleteOnlineUserPlugin(this.$route.params.org_id, target_plugin.id)
              console.log('delete_plugin: ', result)
              break
            case 'sales_counter':
              result = await apiDeleteCounterPlugin(this.$route.params.org_id, target_plugin.id)
              console.log('delete_plugin: ', result)
              // handle sales_counter case
              break
            default:
          }
        }
      }
    },
    async updatePlugin(update_plugins) {
      let plugin_types = Object.keys(update_plugins)

      for (let idx = 0; idx < plugin_types.length; idx++) {
        let plugin_type = plugin_types[idx]

        if (!update_plugins[plugin_type]) {
          continue
        }
        update_plugins[plugin_type] = this.handleRequestData(plugin_type, update_plugins[plugin_type])
        for (let idx2 = 0; idx2 < update_plugins[plugin_type].length; idx2++) {
          let target_plugin = update_plugins[plugin_type][idx2]
          let result = ''
          switch (plugin_type) {
            case 'online_user':
              result = await apiUpdateOnlineUserPlugin(this.$route.params.org_id, target_plugin)
              console.log('update_plugin: ', result)
              break
            case 'sales_counter':
              result = await apiUpdateCounterPlugin(this.$route.params.org_id, target_plugin)
              console.log('update_plugin: ', result)
              break
            default:
            // handle other cases
          }
        }
      }
    },
    handleRequestData(plugin_type, plugins) {
      let tmp_plugins = JSON.parse(JSON.stringify(plugins))
      tmp_plugins.forEach(function (tmp_plugin) {
        switch (plugin_type) {
          case 'online_user':
            break
          case 'sales_counter':
            if (tmp_plugin['cal_type'] === '+') {
              tmp_plugin['step'] = tmp_plugin['multiple']
            } else {
              tmp_plugin['step'] = tmp_plugin['multiple'] * -1
            }

            break
          default:
        }
      })

      console.log('handleRequestData:', tmp_plugins)
      return tmp_plugins
    },
  },
}
</script>

<style scoped>
::v-deep .v-application--wrap {
  min-height: fit-content;
}
.v-application p {
  margin-bottom: 0px;
}
.optimize99-ab-test-header-container {
  background-color: #363e4d !important;
  /* height: 64px; */
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
  /* position: fixed; */
  font-size: 20px;
  /* min-height: 64px; */
  /* z-index: 2; */
  width: 100%;
  color: #fff;
  display: flex;
  flex-direction: column;
}
.optimize99-ab-test-header {
  background-color: #363e4d !important;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
  font-size: 20px;
  min-height: 64px;
  width: 100%;
  color: #fff;
  display: flex;
  flex-direction: row;
}
.optimize99-ab-test-subheader {
  height: 32px;
  background-color: #f1f3f4;
  border-bottom: solid 1px #9aa0a6;
}
.optimize99-ab-test-header > * {
  display: flex;
}
.optimize99-ab-test-header > .title > .back {
  align-items: center;
  border-right: 1px #7e8696 solid;
  height: 100%;
}
.optimize99-ab-test-header > .content {
  justify-content: center;
  align-items: center;
  flex: 1;
  background-color: #363e4d !important;
}
.optimize99-ab-test-header > .action {
  display: flex;
  align-items: center;
}
.opt-icon-container {
  display: flex;
  align-items: center;
  cursor: pointer;
  height: 100%;
  padding-right: 8px;
  padding-left: 8px;
}
.optimize99-ab-test-header > .title {
  align-items: center !important;
}

.optimize99-ab-test-header > .title > .logo {
  display: flex;
  align-items: center;
}

.optimize99-ab-test-header > .title > .logo > img {
  width: 34px;
}
.optimize99-ab-test-header > .title > .experience {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.opt-experience-name {
  font-size: 12px;
  line-height: 1.1;
  color: rgba(255, 255, 255, 0.7);
  overflow: hidden;
  white-space: nowrap;
  width: 8em;
  max-width: 10em;
  text-overflow: ellipsis;
}
.opt-version-name {
  font-size: 20px;
  color: rgba(255, 255, 255);
  line-height: 1.3;
  overflow: hidden;
  white-space: nowrap;
  width: 8em;
  max-width: 10em;
  text-overflow: ellipsis;
}
.device_selector {
  max-width: 200px;
}
.opt-save-btn {
  font-size: 14px !important;
  height: 100% !important;
  border-radius: 0px !important;
  display: flex;
  align-items: center;
  justify-content: center;
}
.btn_action_bg_linear {
  background: rgba(32, 166, 242, 0.9);
}
.btn_action {
  display: flex;
  align-items: center;
  font-size: 0.875rem;
  height: 30px;
  cursor: pointer;
  padding: 0 30px;
  border-radius: 4px;
  color: #fff !important;
}
.optimize99-ab-test-subheader-btn {
  color: rgba(0, 0, 0, 0.54);
}
</style>
